import {deleteJson, getJson, patchJson, postJson, putJson} from '@/util/ajaxUtils';
import {isAzureAuth} from '@/app/AuthUtils';

/**
 * 载入企业微信中的应用信息。
 *
 * @param params 参数为 {agentid, secret}
 * @return {Promise<*>}
 */
export function getWecomAppInfo(params) {
    return getJson('/wecom/apps', {params});
}

export function getAllApps() {
    return getJson('/apps');
}

export function getUserAppMetas(userId) {
    return getJson('/apps/apps-by-user', {params: {userId}});
}

export function getAzureUserAppMetas(userId) {
    return getJson('/apps/azure-apps-by-user', {params: {userId}});
}

export function toggleUserAppPined(userId, appId, pined) {
    return patchJson(`/apps/pined`, {params: {userId, appId, pined}});
}

export function getApp(appId) {
    return getJson(`/apps/${appId}`);
}

export function getUserApp(userId, appId) {
    return getJson('/apps/app-by-user', {params: {userId, appId}});
}

export function getAzureUserApp(userId, appId) {
    return getJson('/apps/azure-app-by-user', {params: {userId, appId}});
}

export function addApp(isAzureAuth, data) {
    return postJson(`/apps/${isAzureAuth}`, {data});
}

export function updateApp(appId, data) {
    return putJson(`/apps/${appId}`, {data});
}

export function updateAppCallback(appId, data) {
    return patchJson(`/apps/${appId}/callback`, {data});
}

export function deleteApp(appId) {
    return deleteJson(`/apps/${appId}`);
}

// -----------------------------------------
// app role
// -----------------------------------------

export function getAppRoles(appId) {
    return getJson(`/approles/${appId}`);
}

export function updateAppRoles(appId, type, roles) {
    return postJson(`/approles/${appId}`, {params: {type}, data: roles});
}

export function deleteAppRole(appRoleId) {
    return deleteJson(`/approles`, {params: {appRoleId}});
}

// -----------------------------------------
// app room
// -----------------------------------------
export function getAppRoomConfigByAppId(appId) {
    return getJson(`/apps/room/config/${appId}`);
}

export function getConfigForce() {
    return getJson(`/apps/room/config-force`);
}

export function getAppUsers(s) {
    return getJson(`/users/app/${s}`);
}

export function addAppRoom(data) {
    return postJson('/apps/room/add', {data});
}

export function getAppRoom(appId) {
    return getJson(`/apps/room/${appId}`);
}

export function getRoomMember(chatId) {
    return getJson(`/apps/room/member/${chatId}`);
}

export function addRoomConfig(data) {
    return postJson('/apps/room/config/add', {data});
}

export function updateRoomConfig(data) {
    return patchJson('/apps/room/config/update', {data});
}

export function allowRoom(appId) {
    return getJson(`/apps/room/allow/${appId}`);
}
